module.exports = __webpack_public_path__ + "img/top-10-add-to-cart.db2312ff.webp";